import { render, staticRenderFns } from "./TransportacionForm.vue?vue&type=template&id=81f641b6"
import script from "./TransportacionForm.vue?vue&type=script&lang=js"
export * from "./TransportacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports